import {isNullOrUndefined} from "orpyx-web-common";

export interface IPatientStatusSource {
    readonly statusId?: number | null;
    readonly statusName?: string | null;
}

export enum PatientStatus {
    Enrolled = 1,
    Active = 2,
    Paused = 3,
    Discontinued = 4,
}

export const PatientStatusLabels: Record<PatientStatus, string> = {
    [PatientStatus.Enrolled]: 'Enrolled',
    [PatientStatus.Active]: 'Active',
    [PatientStatus.Paused]: 'Paused',
    [PatientStatus.Discontinued]: 'Discontinued',
};

export const isPausedPatientStatus = (statusId: number | null | undefined): boolean =>
    statusId === PatientStatus.Paused;

export const resolvePatientStatusName = (patient: IPatientStatusSource | null | undefined): string => {
    if (isNullOrUndefined(patient)) {
        return '';
    }

    const name = patient!.statusName;
    if (!isNullOrUndefined(name) && name!.trim().length > 0) {
        return name!;
    }

    const statusId = patient!.statusId;

    return isNullOrUndefined(statusId) ? '' : PatientStatusLabels[statusId as PatientStatus] ?? '';
};

export const resolvePatientStatusId = (patient: IPatientStatusSource | null | undefined): number | undefined =>
    isNullOrUndefined(patient) || isNullOrUndefined(patient!.statusId) ? undefined : patient!.statusId!;
